import React, {Component} from 'react';
import Merchant from "../merchants/Merchant";
import {CarouselItem, Row} from "mdbreact";

export default class CarouselRowGrouping extends Component {
    render() {
        const { items, itemIndex } = this.props;
        return (
            <CarouselItem itemId={itemIndex}>
                <Row>
                {items.map((item,index) =>
                    <Merchant key={index+1} merchantObj={item}/>
                )}
                </Row>
            </CarouselItem>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselRowGrouping.js